import { DatePicker } from 'components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper } from './CreatedFilter.styled';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTaskSidebarContext } from '../../../../../../../contexts/TaskSidebarContext';
import { formatDate } from '../../../../../../../utilities/date';

export const CreatedFilter: React.FC = () => {
  const { t } = useTranslation();
  const { filters: { created }, setFilters, getDateLabel } = useTaskSidebarContext();

  return (
    <Wrapper>
      <div>
        <DatePicker
          icon={<FontAwesomeIcon icon={faCalendar} />}
          label={t('tasks.dateFrom')}
          isClearable
          value={created.value.from}
          maxDate={created.value.to}
          onChange={(val: Date | null) => setFilters(prevState => {
            return {
              ...prevState,
              created: {
                label: getDateLabel(t('tasks.created') as string, val, prevState.created.value.to),
                value: {
                  from: val,
                  to: prevState.created.value.to
                }
              }
            }
          })}
        />
      </div>
      <div>
        <DatePicker
          icon={<FontAwesomeIcon icon={faCalendar} />}
          label={t('tasks.dateTo')}
          isClearable
          value={created.value.to}
          minDate={created.value.from}
          onChange={(val: Date | null) => setFilters(prevState => {
            return {
              ...prevState,
              created: {
                label: getDateLabel(t('tasks.created') as string, prevState.created.value.from, val),
                value: {
                  from: prevState.created.value.from,
                  to: val
                }
              }
            }
          })}
        />
      </div>
    </Wrapper>
  );
};
